import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from './../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const getRequestBody = (data: any) => {
  const request = {
    ...data,
    status: String(data?.status === 'Activate'),
  }
  return request
}

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}

const addBankCode = (data: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.bankCodeAdd),
    method: 'POST',
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      ...getRequestBody(data),
    },
  }

  console.log({ request })

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { addBankCode }
